module.exports = __webpack_public_path__ + "static/media/graph2.ac15d922.gif";